<template>
  <div>
    <Breadcrumb origin-name="Standorte" origin-path="/locations" :additional-name="location.name" :additional-path="`/locations/${location.id}/manager`" current-name="Verwalter hinzufügen" />
    <h3>Verwalter hinzufügen</h3>
    <form @submit.prevent="submit">
      <div class="form-group">
        <label for="name-input">Vorname*</label>
        <input autofocus
               type="text"
               class="form-control"
               id="first-name-input"
               placeholder="Vorname"
               v-model="firstName"
               required />
      </div>
      <div class="form-group">
        <label for="name-input">Nachname*</label>
        <input type="text"
               class="form-control"
               id="last-name-input"
               placeholder="Nachname"
               v-model="lastName"
               required />
      </div>
      <div class="form-group">
        <label for="name-input">E-Mail*</label>
        <input type="text"
               class="form-control"
               id="email-input"
               placeholder="E-Mail"
               v-model="email"
               required />
      </div>
      <div class="hint mb-3">* Pflichtfelder</div>
      <button class="btn btn-primary" :class="{disabled: loading}">
        Einladen
        <span v-if="loading" class="spinner"></span>
      </button>
    </form>
    <Dialog :visible="deleteDialogVisible"
            title="Deaktivieren?"
            ok-button-text="Ja, deaktivieren!"
            @cancel="deleteDialogVisible = false"
            @ok="disableOrganisation"
            message="Wollen Sie die Organisation deaktivieren?">

    </Dialog>
  </div>
</template>

<script>
import {communicator} from "@/util/communicator.js";
import {broadcast} from "@/util/eventHandler.js";
import Dialog from "@/components/partial/Dialog.vue";
import Breadcrumb from "@/components/partial/Breadcrumb.vue";

export default {
  components: {Breadcrumb, Dialog},
  name: "AddManager",
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      location: {},
      loading: false,
      deleteDialogVisible: false,
      disableDialogVisible: false,
      isNewOrganisation: false
    };
  },
  created() {
    if(this.$route.params.id) this.location = this.$store.state.locations.find(e => String(e.id) === this.$route.params.id);
  },
  methods: {
    async submit() {
      if(this.loading) return;
      try {
        this.loading = true;
        const data = {
          affiliationId: this.location.id,
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email
        };
        if(this.locationId) {
          data.id = this.locationId;
        }
        const response = await communicator.post("/locations/" + this.location.id + "/manager", data);
        console.log("[AddManager] Got response: ", response);
        this.$router.push("/locations/" + this.location.id + "/manager");
      } catch (e) {
        broadcast("error", e.response.data);
      }
      this.loading = false;
    }
  }
};
</script>

<style scoped>

</style>
